var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDailyPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 61,
  viewBox: "0 0 52 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group 1321317116"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M1.625 19.603C1.62807 25.0866 3.48064 30.4088 6.88313 34.7091C10.2856 39.0094 15.0391 42.0364 20.375 43.3005V53.353C20.375 54.8449 20.9676 56.2756 22.0225 57.3305C23.0774 58.3854 24.5082 58.978 26 58.978C27.4918 58.978 28.9226 58.3854 29.9775 57.3305C31.0324 56.2756 31.625 54.8449 31.625 53.353V43.3005C36.9609 42.0364 41.7144 39.0094 45.1169 34.7091C48.5194 30.4088 50.3719 25.0866 50.375 19.603",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group 1321317115"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M26 30.853C39.4619 30.853 50.375 25.8162 50.375 19.603C50.375 13.3898 39.4619 8.35303 26 8.35303C12.5381 8.35303 1.625 13.3898 1.625 19.603C1.625 25.8162 12.5381 30.853 26 30.853Z",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 6161",
  cx: 27.25,
  cy: 17.103,
  r: 1.875,
  fill: "#30343C"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 6164",
  cx: 21.625,
  cy: 37.728,
  r: 1.875,
  fill: "#30343C"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 6162",
  cx: 19.125,
  cy: 22.103,
  r: 1.875,
  fill: "#30343C"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 6163",
  cx: 37.25,
  cy: 23.978,
  r: 1.875,
  fill: "#30343C"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 6161_2",
  cx: 12.875,
  cy: 2.10303,
  r: 1.875,
  fill: "#30343C"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 6165",
  cx: 42.25,
  cy: 8.35303,
  r: 1.875,
  fill: "#30343C"
})))));
export default SvgIconDailyPlus;